<template>
    <div>
        <v-row class="mt-3 ml-3">
            <v-btn
                size="small"
                color="primary"
                prepend-icon="mdi-arrow-left-bold"
                @click="$router.push('/AdminPanel')"
                >
                Powrót do panelu
            </v-btn>
        </v-row>
        <v-row class="ma-16 text-center">
          <v-col cols="12">
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels
                    v-model="ActivePanel"
                    multiple       
                    >
                        <v-expansion-panel elevation="0">
                            <v-expansion-panel-title class="text-h4">Aktywne kody:</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-card
                                    v-for="(item, i) in activeCoupons"
                                    :key="i"
                                    variant="outlined"
                                    class="pa-3 ma-2"
                                >  
                                    <v-row align="center">
                                        <v-col cols="3" class="text-h6 text-primary"> {{ item.name }} </v-col>
                                        <v-col cols="3" class="text-h6 text-weight-light"> Wartość obniżki: {{ item.percentage }}% </v-col>
                                        <v-col cols="3"> Liczba użyć: {{ item.usenum }} </v-col>
                                        <v-col cols="2"> Kupon jednorazowy: <v-icon :color="item.onetime ? 'success' : 'error'" :icon="item.onetime ? 'mdi-check-circle' : 'mdi-close-circle'"> </v-icon></v-col>
                                        <v-col cols="1">
                                            <v-btn icon="mdi-delete" @click="archiveCoupon(item.id)"></v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
            <v-row class="mb-6">
                <v-col cols="12">
                    <v-expansion-panels
                    v-model="ArchivePanel"
                    multiple
                    >
                        <v-expansion-panel elevation="0">
                            <v-expansion-panel-title class="text-h4">Archiwalne kody:</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-card
                                    v-for="(item, i) in oldCoupons"
                                    :key="i"
                                    variant="outlined"
                                    class="pa-3 ma-2"
                                >  
                                    <v-row align="center">
                                        <v-col cols="3" class="text-h6 text-primary"> {{ item.name }} </v-col>
                                        <v-col cols="3" class="text-h6 text-weight-light"> Wartość obniżki: {{ item.percentage }}% </v-col>
                                        <v-col cols="3"> Liczba użyć: {{ item.usenum }} </v-col>
                                        <v-col cols="3"></v-col>
                                    </v-row>
                                </v-card>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
            <v-divider class="border-opacity-75"></v-divider>
            <v-row class="mt-6">
                <v-col cols="12">
                    <p class="text-h5"> Dodawanie nowego kodu promocyjnego </p>
                </v-col>
                <v-col cols="12">
                    <v-form ref="valid">
                        <v-row class="ma-16 align-center">
                            <v-col cols="1"></v-col>
                            <v-col cols="5">
                                <v-text-field
                                    v-model="coupname"
                                    label="Kupon"
                                    required
                                    variant="outlined"
                                    :rules="fieldRules"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    v-model="discount"
                                    label="Wartość % obniżki"
                                    required
                                    type="number"
                                    variant="outlined"
                                    :rules="fieldRules"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-checkbox 
                                label="Kupon jednorazowy"
                                v-model="jednorazowy"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="1"></v-col>
                        </v-row>
                        <v-row justify="center" class="mb-2">
                            <v-btn color="primary" @click="formValid()">Dodaj</v-btn>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-snackbar
        v-model="msgSnackbar"
        color="secondary"
        >
        Kupon dodany
        <template v-slot:actions>
            <v-btn
            icon="mdi-close"
            color="red"
            @click="msgSnackbar = false"
            >            
            </v-btn>
        </template>
        </v-snackbar>
    </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import { mapGetters } from "vuex";

  export default {
    data () {
      return {
        ArchivePanel: [0, 1],
        ActivePanel: [0, 1],
        coupname: '',
        discount: '',
        msgSnackbar: false,
        activeCoupons: [],
        oldCoupons: [],
        jednorazowy: false,
        fieldRules: [
            value => {
            if (value) return true
            return 'Pole nie może być puste.'
            },
        ],
      }
    },
    computed: {
        ...mapGetters(['isLoggedIn'])
    },
    created() {
        if(this.isLoggedIn !== true){
            this.$router.push('/AdminLogin')
        }
    },
    methods: {
      async formValid() {
        const { valid } = await this.$refs.valid.validate()
        if(valid) {
            if(this.discount < 100 && this.discount > 0) {
                this.newCoupon();
                this.msgSnackbar = true;
            }
        }
      },

      newCoupon() {
        let data = moment().format("YYYY-MM-DD");

        axios
        .post(`${process.env.VUE_APP_API}/coupon_add`, {'name': this.coupname, 'perc': this.discount, 'today': data, 'onetime': this.jednorazowy, 'admin_token': `${process.env.VUE_APP_ADMIN_TOKEN}`}, {
            headers: { 'Content-Type': 'application/json' }
        })

        setTimeout( () => location.reload(), 4000);
      },

      archiveCoupon(id) {
        axios
        .put(`${process.env.VUE_APP_API}/coupon_rem`, {'id': id, 'admin_token': `${process.env.VUE_APP_ADMIN_TOKEN}`}, {
            headers: { 'Content-Type': 'application/json' }
        })

        setTimeout( () => location.reload(), 1000);
      }
    },
    mounted () {
        axios
        .get(`${process.env.VUE_APP_API}/coupons_active`, {params: {'admin_token': `${process.env.VUE_APP_ADMIN_TOKEN}`}})
        .then((resp) => {
          this.activeCoupons = resp.data;
        });

        axios
        .get(`${process.env.VUE_APP_API}/coupons_old`, {params: {'admin_token': `${process.env.VUE_APP_ADMIN_TOKEN}`}})
        .then((resp) => {
          this.oldCoupons = resp.data;
        });
    }
}
</script>